import { useEffect } from 'react'
import { useThemeStore } from '@/stores/themeStore'

/**
 * 主题管理 Hook
 * 提供主题监听、系统主题变化检测功能
 * @returns 主题状态和操作方法
 */
export function useTheme() {
  const { theme, resolvedTheme, setTheme, toggleTheme } = useThemeStore()

  // 监听系统主题变化
  useEffect(() => {
    if (theme !== 'system') return

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    const handleChange = () => {
      const newResolvedTheme = mediaQuery.matches ? 'dark' : 'light'
      useThemeStore.setState({ resolvedTheme: newResolvedTheme })
      document.documentElement.classList.toggle(
        'dark',
        newResolvedTheme === 'dark'
      )
    }

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [theme])

  // 初始化主题
  useEffect(() => {
    const root = document.documentElement
    root.classList.remove('light', 'dark')
    root.classList.add(resolvedTheme)
  }, [resolvedTheme])

  return {
    theme,
    resolvedTheme,
    setTheme,
    toggleTheme,
    isDark: resolvedTheme === 'dark',
    isLight: resolvedTheme === 'light',
    isSystem: theme === 'system',
  }
}
